import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { CamEnerjiEditComponent } from './cam-enerji-edit.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'cam-enerji-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--cam-enerji" [style.--accent]="'#a855f7'" [style.--accent-rgb]="'168,85,247'" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">⚡ ENERJİ KAYDI</div>
        <div class="ej-ana">{{ d('kwh') || 0 }} <span class="ej-birim">kWh</span></div>
        <div class="gc-stat-bolge">
          @if (d('islemSuresi')) {
            <div class="gc-stat-satir">
              <span class="gc-stat-isim">SÜRE</span>
              <span class="gc-stat-deger gc-stat-deger--cyan">{{ d('islemSuresi') }} dk</span>
            </div>
          }
          @if (d('parcaAdedi')) {
            <div class="gc-stat-satir">
              <span class="gc-stat-isim">PARÇA</span>
              <span class="gc-stat-deger gc-stat-deger--yesil">{{ d('parcaAdedi') }} ad.</span>
            </div>
          }
          @if (parcaBasiKwh() !== null) {
            <div class="gc-stat-satir">
              <span class="gc-stat-isim">PARÇA BAŞI</span>
              <div class="gc-stat-bar">
                <div class="gc-stat-bar-dolgu gc-stat-bar--mavi" [style.width.%]="gorunur() ? parcaBarYuzde() : 0"></div>
              </div>
              <span class="gc-stat-deger gc-stat-deger--mavi">{{ parcaBasiKwh() }}</span>
            </div>
          }
        </div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 100 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .ej-ana { font-size: 22px; font-weight: 900; color: #a855f7; text-shadow: 0 0 12px rgba(168,85,247,.3); margin-top: 4px; }
    .ej-birim { font-size: 11px; font-weight: 600; opacity: .7; }
  `],
})
export class CamEnerjiKartComponent extends GameCardBase {
  parametreler = input<any>();
  _hesap = input<any>();
  constructor() { super(); }
  d(ismi: string) { return paramDeger(this.parametreler()?.ek, ismi); }
  parcaBasiKwh = computed(() => {
    const kwh = +(this.d('kwh') || 0);
    const adet = +(this.d('parcaAdedi') || 0);
    if (!kwh || !adet) return null;
    return (kwh / adet).toFixed(2);
  });
  parcaBarYuzde = computed(() => {
    const pb = +(this.parcaBasiKwh() || 0);
    return Math.min(pb * 10, 100);
  });
}

@Component({
  selector: 'cam-enerji-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#a855f7">
      <div class="sk-icerik">
        <div class="sk-baslik">⚡ Enerji Kaydı</div>
        @if (d('islemSuresi')) { <div class="sk-alt">{{ d('islemSuresi') }} dk</div> }
      </div>
      <div class="sk-sag">
        <span style="font-size:14px;font-weight:700;color:#a855f7">{{ d('kwh') || 0 }} kWh</span>
        @if (d('parcaAdedi')) { <span style="font-size:10px;color:var(--py-metin-ucuncul)">{{ d('parcaAdedi') }} parça</span> }
      </div>
    </div>
  `,
})
export class CamEnerjiKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
}

@DinamikBilesen({
  id: 'cam-enerji',
  baslik: 'Enerji Kaydı',
  aciklama: 'Enerji tüketim ve maliyet kaydı',
  ikon: 'thunderbolt',
  kategori: 'cam-isleme',
})
class CamEnerji {
  paylas_kutusu = CamEnerjiEditComponent;
  paylasilmis_kart = CamEnerjiKartComponent;
  paylasilmis_kart_sade = CamEnerjiKartSadeComponent;
}
